import Axios from "axios";


export const cars = {
    namespaced: true,
    state: {
        vehicles: null,
        singleVehicle: null,
        carNum: 0,
        singleCarHistory: null,
    },
    actions: {
        async fetchCars(context){
            let userToken = JSON.parse(localStorage.getItem("user"));
            let options = {
              headers: { Authorization: `Bearer ${userToken.jwt}` },
            };
            const response = await Axios.get(
                "https://api.rightcloud.pl/renty-cars",
                options
              )
              const responseData = await response
              if(responseData.status !== 200){
                const error = new Error(responseData.message || 'Failed to fetch cars. Please try again later.');
                throw error;
              } 
              context.commit('setCars', responseData.data)
        },
        async fetchCarHistory (context, id){
          let userToken = JSON.parse(localStorage.getItem("user"));
          let options = {
            headers: { Authorization: `Bearer ${userToken.jwt}` },
          };
          const response = await Axios.get(`https://api.rightcloud.pl/renty-shifts?selectedCar=${id}&_sort=endDate:DESC`, options)
          const responseData = await response;
          if(responseData.status !== 200){
            const error = new Error(responseData.message || 'Failed to fetch cars. Please try again later.');
            throw error;
          }
          context.commit('setCarHistory', responseData.data)
        },
        async updateDamage(context, {id, damageChart}){
          let userToken = JSON.parse(localStorage.getItem("user"));
          let options = {
            headers: { Authorization: `Bearer ${userToken.jwt}` },
          };
          const response = await Axios.put(
            `https://api.rightcloud.pl/renty-cars/${id}`, {damageChart: damageChart},
            options
          )
          const responseData = await response
          if(responseData.status !== 200){
            const error = new Error(responseData.message || 'Failed to fetch cars. Please try again later.');
            throw error;
          } 
        },
        async updateCar(context, {payload, id}){
          let userToken = JSON.parse(localStorage.getItem("user"));
          let options = {
            headers: { Authorization: `Bearer ${userToken.jwt}` },
          };
          const response = await Axios.put(
            `https://api.rightcloud.pl/renty-cars/${id}`, payload,
            options
          )
          const responseData = await response
          if(responseData.status !== 200){
            const error = new Error(responseData.message || 'Failed to update car. Please try again later.');
            throw error;
          } 
        },
        async getCarNum(context, payload){
          let userToken = JSON.parse(localStorage.getItem("user"));
          let options = {
            headers: { Authorization: `Bearer ${userToken.jwt}` },
          };
          const response = await Axios.get(
            "https://api.rightcloud.pl/renty-cars/count",
            options
          )
          const responseData = await response
          if(responseData.status !== 200){
            const error = new Error(responseData.message || 'Failed to fetch cars. Please try again later.');
            throw error;
          } 
          context.commit('setCarNum', responseData.data)
        },
        async addNewCar(context, payload){
            let userToken = JSON.parse(localStorage.getItem("user"));
            let options = {
              headers: { Authorization: `Bearer ${userToken.jwt}` },
            };
            const response = await Axios.post(
                "https://api.rightcloud.pl/renty-cars",
                payload,
                options
              )
              const responseData = await response
              if(responseData.status !== 200){
                const error = new Error(responseData.message || 'Failed to add new car. Please try again later.');
                throw error;
              } 

        },
        async fetchSingle(context, payload){
          let userToken = JSON.parse(localStorage.getItem("user"));
          let options = {
            headers: { Authorization: `Bearer ${userToken.jwt}` },
          };
          const response = await Axios.get(
              `https://api.rightcloud.pl/renty-cars/${payload}`,
              options
            )
            const responseData = await response
            if(responseData.status !== 200){
              const error = new Error(responseData.message || 'Failed to get car. Please try again later.');
              throw error;
            }
            context.commit('setSingle', responseData.data) 
        }
    },
    mutations: {
        setCars(state,payload){
            state.vehicles = payload;
        },
        setSingle(state, payload){
            state.singleVehicle = payload;
        },
        setCarNum(state,payload){
          state.carNum = payload
        },
        setCarHistory(state,payload){
          state.singleCarHistory = payload;
        }
    },
    getters: {
        getCars(state){
            return state.vehicles
        },
        getSingle(state){
            return state.singleVehicle
        },  
        getActiveCars(state){
          let active = state.vehicles.filter(car => !car.notAvailable)
          return active.sort((a,b) => a.regPlate !== b.regPlate ? a.regPlate < b.regPlate ? -1 : 1 : 0)
        },
        getTodoById: (state) => (id) => {
          return state.vehicles.find(vehicle => vehicle.id === id)
        },
        getCarNum(state){
          return state.carNum
        },
        getCarHistory(state){
          return state.singleCarHistory
        }
    }
}